import React, { useEffect, MouseEvent } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import SwiperUnrestricted from '../../../swiper/swiperUnrestricted'
import SwiperNotLoggined from '../../../swiper/swiperLoginRequied'
import SwiperMembershipRequied from '../../../swiper/swiperMembershipRequied'
import { isUserPro } from '../../../../utils/isUserPro'

import { RootState } from '../../../../store/rootReducer'
import { PhotoType } from '../../../../store/commonTypes'

import moment from 'moment-mini'
import paths from '../../../../paths'
import { fixAppContainer, unfixAppContainer } from '../../../../store/common/commonSlice'
import './photoPopup.sass'

interface Props {
    last: boolean
    first: boolean
    photo: PhotoType
    onClose: () => void
    changePhoto: (e?: MouseEvent | KeyboardEvent | TouchEvent, prev?: boolean) => void
    type?: string
}

const Index: React.FunctionComponent<Props> = ({ photo, onClose, type }: Props) => {
    const location = useLocation()
    const dispatch = useDispatch()

    const self = location.pathname.includes('/membre')

    const { user } = useSelector((state: RootState) => state.member)
    const userPhotos = useSelector((state: RootState) => (self ? state.member.userPhotos : state.profile.userPhotos))

    const { member_type } = user || { member_type: undefined }
    const filter = type || 'free'
    const list = userPhotos

    useEffect(() => {
        dispatch(fixAppContainer())
        if (document.querySelector('.swiper-button-next')) {
            document.querySelector('.swiper-button-next').addEventListener('click', (e) => {
                e.stopPropagation()
            })
            document.querySelector('.swiper-button-prev').addEventListener('click', (e) => {
                e.stopPropagation()
            })
        }

        return () => {
            dispatch(unfixAppContainer())
        }
    }, [])

    return (
        <div className="photoPopup" onClick={onClose}>
            <div className="overlay">
                <div className="info">
                    <div className="avatar">
                        <img src={photo.user.avatar_url} alt="" />
                    </div>
                    <div className="data">
                        <Link to={paths.profile.toPath({ nick: photo.user.nick })} className="nick">
                            {photo.user.nick}
                        </Link>
                        <div className="date">{moment(photo.date * 1000).format('DD/MM/YYYY')}</div>
                    </div>
                </div>
                {user ? (
                    filter === 'pro' || filter === 'private' ? (
                        isUserPro(member_type) ? (
                            <SwiperUnrestricted list={list} photo={photo} />
                        ) : (
                            <SwiperMembershipRequied list={list.filter((item) => item.type === 'pro')} photo={photo} />
                        )
                    ) : (
                        <SwiperUnrestricted list={list} photo={photo} />
                    )
                ) : (
                    <SwiperNotLoggined list={list} photo={photo} />
                )}
                {/*{photo.comments && <div className="description">{photo.comments}</div>}*/}
            </div>
        </div>
    )
}

export default Index
